module.exports = __webpack_public_path__ + "img/applicants_employment_data.4d5b970d.svg";